import { Helper } from '../Helper';
export class MapReduceHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        sb.emitOp(node, 'SWAP');
        sb.emitSysCall(node, 'Neo.Iterator.Create');
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.rawIteratorReduce({
            each: this.each,
        }));
    }
}

//# sourceMappingURL=MapReduceHelper.js.map
